export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/decc719ac0c1523cc2040d71b927dcbc.svg";